/**
 * Automation Module Constants
 */

// --- Messages Automation API URLs (migrated from utils/constants.ts) ---
export const GET_ONBOARDING_URL = '/api/Automations/OnBoarding';
export const GENERATE_PREDEFINED_AUTOMATIONS_URL = '/api/Automations/GeneratePreDefinedAutomations';
export const GET_ALL_AUTOMATIONS_URL = '/api/Automations/GetAllAutomations';
export const GET_LISTING_MANAGEMENT_URL = '/api/ListingManagement';
export const UPDATE_ACTIVITY_URL = '/api/Automations/UpdateActivity';
export const SET_ONBOARDING_COMPLETE_URL = '/api/Automations/SetOnBoradingComplete';
export const GET_MASTER_DATA_URL = '/api/Automations/GetMasterData';
export const GET_AUTOMATION_BY_ID_URL = '/api/Automations/GetAutomationById';
export const UPDATE_AUTOMATION_URL = 'api/Automations/UpdateAutomation';
export const GET_UNSYNCED_PROPERTIES_URL = '/api/ListingManagement/GetUnSyncedProperties';
export const SYNC_PROPERTY_URL = '/api/ListingManagement/SyncProperty';

// --- Nabeeh Services API URL ---
export const LIST_NABEEH_SERVICES_URL = '/api/Automations/ListNabeehServices';
export const LIST_NABEEH_SERVICE_CATEGORIES_URL = '/api/Automations/ListNabeehServiceCategories';

// --- Checklist Items API URL ---
export const LIST_CHECKLIST_ITEMS_URL = '/api/Automations/ListChecklistItems';
export const CREATE_CHECKLIST_ITEM_URL = '/api/Automations/CreateChecklistItem';
export const DELETE_CHECKLIST_ITEM_URL = '/api/Automations/DeleteChecklistItem';

// --- Service Providers API URL ---
export const LIST_SERVICE_PROVIDERS_URL = '/api/User/ListServiceProviders';

// --- Task Automation API URLs ---
export const CREATE_TASK_AUTOMATION_URL = '/api/Automations/CreateTaskAutomation';
export const GET_TASK_AUTOMATION_BY_ID_URL = '/api/Automations/GetTaskAutomationById';

// --- Tasks Automation API URLs ---
export const DELETE_TASK_AUTOMATION_URL = '/api/Automations/DeleteTaskAutomation';
export const UPDATE_TASK_AUTOMATION_URL = '/api/Automations/UpdateTaskAutomation';
